export default __webpack_public_path__ + "static/media/measuring.99a01b82.jpg";